export default __webpack_public_path__ + "static/media/general.ed9ded79.png";